import React, { useEffect } from "react";
import { Separator } from "../../ui/separator";

const DataTerms = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
      <main className="flex-grow bg-white py-8 md:py-12">
        <div className="container mx-auto px-2 md:px-4">
          <div className="max-w-4xl mx-auto">
            {/* Page Header */}
            <div className="mb-8 md:mb-12">
              <h1 className="text-3xl font-bold mb-6 text-center text-[#2D0052]">
                Data Processing Agreement
              </h1>
              <p className="text-sm text-gray-500 text-center mb-8">
                Effective Date: 13 April 2024
              </p>
            </div>

            {/* Content */}
            <div className="prose prose-lg max-w-none">
              <p className="text-base leading-relaxed text-gray-800 mb-4">
                Registered Company Name: TTL Media Private Limited ("Platform")
              </p>

              <p className="text-base leading-relaxed text-gray-800 mb-4">
                Parties:
              </p>

              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  <strong>Enterprise Client ("Controller")</strong>:
                  Individuals, companies, or other entities commissioning
                  campaigns and determining the purposes and means of Personal
                  Data processing.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  <strong>Creators ("Data Providers")</strong>: Influencers or
                  content creators who supply Personal Data to the Platform and
                  retain control over their personal information.
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  <strong>
                    TTL Media Private Limited, trading as Oye Creators
                    ("Processor")
                  </strong>
                  : A marketplace platform that aggregates, facilitates, and
                  operates campaigns using AI, human resources, and RPAs.
                  Processor acts on documented instructions of Controllers and
                  Creators and processes Personal Data—including publicly
                  available data from social media—to deliver services.
                </li>
              </ul>

              <p className="text-base leading-relaxed text-gray-800 mt-6 mb-4">
                This Data Processing Agreement ("Agreement") is an integral part
                of the Services Agreement between the Parties. It ensures all
                Personal Data processing activities comply with:
              </p>

              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  The EU General Data Protection Regulation (Regulation (EU)
                  2016/679) ("GDPR").
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  The Indian Digital Personal Data Protection Act, 2023 ("DPDP
                  Act").
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Other relevant international and local privacy laws.
                </li>
              </ul>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  1. Definitions
                </h2>
                <p className="text-base leading-relaxed text-gray-800 mb-2">
                  1.1 <strong>Personal Data</strong>: Any information relating
                  to an identified or identifiable natural person, including
                  names, contact details, demographic attributes, usage logs,
                  and special categories like health or biometric data when
                  applicable.
                </p>
                <p className="text-base leading-relaxed text-gray-800 mb-2">
                  1.2 <strong>Processing</strong>: Any operation performed on
                  Personal Data, such as collection, storage, retrieval,
                  modification, deletion, disclosure, or analysis.
                </p>
                <p className="text-base leading-relaxed text-gray-800 mb-2">
                  1.3 <strong>Controller</strong>: The Party (Enterprise Client
                  or Creator) that determines the why and how of Personal Data
                  Processing.
                </p>
                <p className="text-base leading-relaxed text-gray-800 mb-2">
                  1.4 <strong>Processor</strong>: TTL Media Private Limited,
                  executing Processing on behalf of Controllers or assisting
                  Creators as Data Controllers of their own data.
                </p>
                <p className="text-base leading-relaxed text-gray-800 mb-2">
                  1.5 <strong>Sub-processor</strong>: Any third-party vendor
                  engaged by Processor to carry out specific Processing tasks
                  under a binding contract.
                </p>
                <p className="text-base leading-relaxed text-gray-800 mb-2">
                  1.6 <strong>Data Subject</strong>: A natural person whose data
                  is processed.
                </p>
                <p className="text-base leading-relaxed text-gray-800 mb-2">
                  1.7 <strong>Services Agreement</strong>: The primary contract
                  under which services are delivered, incorporating this DPA by
                  reference.
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  2. Scope & Purpose of Processing
                </h2>
                <p className="text-base leading-relaxed text-gray-800 mb-2">
                  2.1 <strong>Subject Matter</strong>: The Processor will handle
                  Personal Data to deliver services under Controllers'
                  instructions, including campaign planning, analytics, billing,
                  onboarding, and marketplace operations.
                </p>
                <p className="text-base leading-relaxed text-gray-800 mb-2">
                  2.2 <strong>Duration</strong>: Processing continues for the
                  duration of the Services Agreement and thereafter as required
                  by law or for legitimate archival and defense of claims.
                </p>
                <p className="text-base leading-relaxed text-gray-800 mb-2">
                  2.3 <strong>Categories of Data Subjects</strong>: Employees,
                  contractors, customers of Controllers; Creators and audience
                  members; end users.
                </p>
                <p className="text-base leading-relaxed text-gray-800 mb-2">
                  2.4 <strong>Types of Personal Data</strong>: Identity,
                  Contact, Demographic, Technical, Usage, Performance, Public,
                  and Special Category Data.
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  3. Roles & Responsibilities
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  4. Security Measures
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  5. Sub-Processors
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  6. Data Subject Rights & Breach Notification
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  7. Audit & Inspection
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  8. International Data Transfers
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  9. Term & Data Deletion
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  10. Confidentiality
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  11. Indemnification
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  12. Limitation of Liability
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  13. Governing Law & Dispute Resolution
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  14. Miscellaneous
                </h2>
                <p className="text-base leading-relaxed text-gray-800">
                  [Content to be provided]
                </p>
              </section>

              <Separator className="my-8 bg-gray-200" />

              <section className="mb-8">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-[#D9008D]">
                  Appendix A: Authorized Sub-Processors
                </h2>
                <ul className="list-disc ml-6 space-y-2">
                  <li className="text-base leading-relaxed text-gray-800">
                    AWS (hosting and infrastructure)
                  </li>
                  <li className="text-base leading-relaxed text-gray-800">
                    Google Analytics (analytics)
                  </li>
                  <li className="text-base leading-relaxed text-gray-800">
                    Stripe (payment processing)
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </main>
  )
}

export default DataTerms
